import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import GridContainer from 'components/UI/Grid/GridContainer';
import WithPermission from 'components/User/WithPermission';
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import SweetAlert from 'react-bootstrap-sweetalert';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';

class Commands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      action: null,
      message: null,
      adId: '',
      cacheKey: '',
    };
  }

  executeCommand = () => {
    const { action } = this.state;
    // call prop that was set in state
    action();
    // hide the Alert modal
    this.setState({ showAlert: false });
  };

  render() {
    const { showAlert, message, adId, cacheKey } = this.state;
    const {
      classes,
      t,
      restartIndex,
      populateIndex,
      auditorIndex,
      deleteCategoriesCache,
      adIndex,
      loadingIndex,
      deleteCacheKey,
      loadingDeleteCacheKey,
      resetProfileMetrics,
    } = this.props;

    return (
      <React.Fragment>
        {showAlert && (
          <SweetAlert
            warning
            style={{ display: 'block', padding: 30 }}
            title=""
            onConfirm={() => {}}
            showConfirm={false}
          >
            <h4>{t('commands.confirmation.question') + message}</h4>
            <b>{t('common.delete.info')}</b>
            <GridContainer
              style={{ marginTop: 20, padding: '0 20px' }}
              justify="space-between"
            >
              <GridItem>
                <Button
                  simple
                  color="primary"
                  onClick={() =>
                    this.setState({ showAlert: false, action: null })
                  }
                >
                  {t('commands.confirmation.cancel') + message}
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  data-test="submit"
                  color="danger"
                  onClick={this.executeCommand}
                >
                  {message}
                </Button>
              </GridItem>
            </GridContainer>
          </SweetAlert>
        )}

        <div className={classes.pageContainer}>
          <h3 className={classes.title}>{t('commands.title')}</h3>
          <div className={classes.contentContainer}>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.reset_index.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <Button
                    data-test="restartIndex"
                    simple
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: restartIndex,
                        message: t('commands.reset_index.btn'),
                      })
                    }
                  >
                    {t('commands.reset_index.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.populate_index.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <Button
                    simple
                    data-test="populateIndex"
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: populateIndex,
                        message: t('commands.populate_index.btn'),
                      })
                    }
                  >
                    {t('commands.populate_index.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.paidad_auditor.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <Button
                    simple
                    data-test="paidadAuditor"
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: auditorIndex,
                        message: t('commands.paidad_auditor.btn'),
                      })
                    }
                  >
                    {t('commands.paidad_auditor.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.delete_categories_cache.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <Button
                    simple
                    data-test="delete-categories-cache"
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: deleteCategoriesCache,
                        message: t('commands.delete_categories_cache.btn'),
                      })
                    }
                  >
                    {t('commands.delete_categories_cache.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.ad_index.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <TextField
                    label={t('commands.ad_index.label')}
                    name="ad"
                    InputProps={{
                      value: adId,
                      onChange: e => this.setState({ adId: e.target.value }),
                      type: 'number',
                    }}
                  />
                  <Button
                    simple
                    data-test="ad-index-cache"
                    color="primary"
                    disabled={loadingIndex}
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: () => adIndex(adId),
                        message: t('commands.ad_index.btn'),
                      })
                    }
                  >
                    {t('commands.ad_index.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.cache_key.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <TextField
                    label={t('commands.cache_key.label')}
                    name="cacheKey"
                    InputProps={{
                      value: cacheKey,
                      onChange: e =>
                        this.setState({ cacheKey: e.target.value }),
                      type: 'text',
                    }}
                  />
                  <Button
                    simple
                    data-test="cache-key"
                    color="primary"
                    disabled={loadingDeleteCacheKey}
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: () => deleteCacheKey(cacheKey),
                        message: t('commands.cache_key.btn'),
                      })
                    }
                  >
                    {t('commands.cache_key.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
            <GridContainer alignItems="center" justify="space-between">
              <GridItem>{t('commands.reset_profile_metrics.title')}</GridItem>
              <GridItem>
                <WithPermission allowPermissions={[]}>
                  <Button
                    simple
                    data-test="reset-profile-metrics"
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showAlert: true,
                        action: resetProfileMetrics,
                        message: t('commands.reset_profile_metrics.btn'),
                      })
                    }
                  >
                    {t('commands.reset_profile_metrics.btn')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Commands.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  restartIndex: PropTypes.func.isRequired,
  populateIndex: PropTypes.func.isRequired,
  auditorIndex: PropTypes.func.isRequired,
  deleteCategoriesCache: PropTypes.func.isRequired,
  adIndex: PropTypes.func.isRequired,
  loadingIndex: PropTypes.bool.isRequired,
  deleteCacheKey: PropTypes.func.isRequired,
  loadingDeleteCacheKey: PropTypes.bool.isRequired,
  resetProfileMetrics: PropTypes.func.isRequired,
};

export default withTranslation()(
  withStyles({ ...extendedTablesStyle, ...sweetAlertStyle })(Commands),
);
